import { render } from "./TheBandSection.vue?vue&type=template&id=0f416f83&scoped=true"
import script from "./TheBandSection.vue?vue&type=script&lang=js"
export * from "./TheBandSection.vue?vue&type=script&lang=js"

import "./TheBandSection.vue?vue&type=style&index=0&id=0f416f83&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f416f83"]])

export default __exports__